var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import L from 'leaflet';
//import 'leaflet/dist/leaflet.css';
import React, { useEffect, useState } from 'react';
import { Map, Marker, Popup, TileLayer } from 'react-leaflet';
import MarkerClusterGroup from 'react-leaflet-markercluster';
//import 'react-leaflet-markercluster/dist/styles.min.css';
import { Bar, CartesianGrid, ComposedChart, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import markerSubstation from '../assets/img/marker-eplus.png';
import markerSequencer from '../assets/img/marker-timer.png';
import markerBlueIcon from '../assets/img/placemark_blue@2x.png';
import markerGreenIcon from '../assets/img/placemark_green@2x.png';
import markerOrangeIcon from '../assets/img/placemark_orange@2x.png';
import markerMagentaIcon from '../assets/img/placemark_purple@2x.png';
import markerRedIcon from '../assets/img/placemark_red@2x.png';
import markerYellowIcon from '../assets/img/placemark_yellow@2x.png';
import HeaderTextDivider from '../header-text-divider';
import { loadCssDesign } from '../utils/Utils';
var greenIcon = new L.Icon({
    iconUrl: markerGreenIcon,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
});
var redIcon = new L.Icon({
    iconUrl: markerRedIcon,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
});
var blueIcon = new L.Icon({
    iconUrl: markerBlueIcon,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -50],
});
var yellowIcon = new L.Icon({
    iconUrl: markerYellowIcon,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -50],
});
var orangeIcon = new L.Icon({
    iconUrl: markerOrangeIcon,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -50],
});
var magentaIcon = new L.Icon({
    iconUrl: markerMagentaIcon,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -50],
});
var substationIcon = new L.Icon({
    iconUrl: markerSubstation,
    iconSize: [56, 56],
    iconAnchor: [28, 56],
    popupAnchor: [1, -50],
});
var sequencerIcon = new L.Icon({
    iconUrl: markerSequencer,
    iconSize: [46, 46],
    iconAnchor: [23, 46],
    popupAnchor: [10, -23],
});
var ClsmViewComponent = function (_a) {
    var json_data = _a.json_data, getSelectedClientLanguage = _a.getSelectedClientLanguage, getTranslated = _a.getTranslated, CONSTANTS_REQ = _a.CONSTANTS_REQ, _b = _a.projectType, projectType = _b === void 0 ? 'kiosk' : _b, css_id = _a.css_id, css_json = _a.css_json, geti18nText = _a.geti18nText, Switch = _a.Switch, requestGet = _a.requestGet, Row = _a.Row, Col = _a.Col, Spin = _a.Spin, Statistic = _a.Statistic, RESPONSE = _a.RESPONSE;
    var _c = useState(JSON.parse(json_data)), jsonData = _c[0], setJsonData = _c[1];
    var selLang = getSelectedClientLanguage();
    var _d = useState(false), showModal = _d[0], setShowModal = _d[1];
    var _e = useState({}), currentConsumption = _e[0], setCurrentConsumption = _e[1];
    var _f = useState(false), grouping = _f[0], setGrouping = _f[1];
    var _g = useState(false), lightVisible = _g[0], setLightVisible = _g[1];
    var _h = useState(null), light = _h[0], setLight = _h[1];
    var _j = useState(null), substation = _j[0], setSubstation = _j[1];
    var _k = useState(false), substationVisible = _k[0], setSubstationVisible = _k[1];
    var _l = useState(), substations = _l[0], setSubstations = _l[1];
    var _m = useState(null), substationPopUp = _m[0], setSubstationPopUp = _m[1];
    var _o = useState(), items = _o[0], setItems = _o[1];
    var _p = useState(null), popUp = _p[0], setPopUp = _p[1];
    var _q = useState(undefined), bounds = _q[0], setBounds = _q[1];
    var _r = useState(false), substationsLoaded = _r[0], setSubstationsLoaded = _r[1];
    var _s = useState(false), lightsLoaded = _s[0], setLightsLoaded = _s[1];
    var _t = useState(false), loading = _t[0], setLoading = _t[1];
    var _u = useState(null), powerMax = _u[0], setPowerMax = _u[1];
    var _v = useState(null), chartPower = _v[0], setChartPower = _v[1];
    var _w = useState(null), energyMax = _w[0], setEnergyMax = _w[1];
    var _x = useState(null), chartEnergy = _x[0], setChartEnergy = _x[1];
    var _y = useState(false), fetchError = _y[0], setFetchError = _y[1];
    useEffect(function () {
        loadCssDesign(css_id, css_json, CONSTANTS_REQ);
    }, []);
    useEffect(function () {
        setFetchError(false);
        if (jsonData.type === 'map') {
            fetch();
        }
        if (jsonData.type === 'chart') {
            fetchChartData();
        }
    }, []);
    function fetchChartData() {
        setChartPower([]);
        setChartEnergy([]);
        setPowerMax(0);
        setEnergyMax(0);
        setLoading(true);
        requestGet(CONSTANTS_REQ.CLSM.REPORT_CHART_CONSUMPTION, __assign({ projectId: jsonData.project.key }, { period: jsonData.period ? jsonData.period.key : 'last-month', lang: getSelectedClientLanguage() })).then(function (response) {
            setLoading(false);
            if (response.status === RESPONSE.OK) {
                var data = JSON.parse(response.data);
                setChartPower(data[0]);
                setChartEnergy(data[1]);
                setPowerMax(data[2] ? data[2] : 0);
                setEnergyMax(data[3]);
            }
            else {
                setFetchError(true);
            }
        });
    }
    useEffect(function () {
        if (substationsLoaded && lightsLoaded) {
            extendBounds(substations, items);
        }
    }, [substationsLoaded, lightsLoaded]);
    var setDefaultFilterValue = function () {
        return [
            { field: 'active', condition: 'equals_bool', value: 1 },
            { field: 'project_id', condition: 'equals', value: jsonData.project.key },
        ];
    };
    var fetch = function () {
        requestGet(CONSTANTS_REQ.CLSM.CURRENT_CONSUMPTION, {
            projectId: jsonData.project.key,
        }).then(function (result) {
            if (result.status === RESPONSE.OK) {
                setCurrentConsumption(JSON.parse(result.data));
            }
            else {
                setFetchError(true);
            }
        });
        requestGet(CONSTANTS_REQ.CLSM.SUBSTATION_LIST, {
            search: encodeURI(JSON.stringify(setDefaultFilterValue())),
            max: 100000,
            offset: 0,
        }).then(function (result) {
            if (result.status === RESPONSE.OK) {
                var data = JSON.parse(result.data);
                setSubstations((data.content));
                setSubstationsLoaded(true);
            }
            else {
                setFetchError(true);
            }
        });
        requestGet(CONSTANTS_REQ.CLSM.LIGHTS_LIST, {
            search: encodeURI(JSON.stringify(setDefaultFilterValue())),
            max: 100000,
            offset: 0,
        }).then(function (result) {
            if (result.status === RESPONSE.OK) {
                var data = JSON.parse(result.data);
                setItems(data.content);
                setLightsLoaded(true);
            }
            else {
                setFetchError(true);
            }
        });
        setGrouping(true);
    };
    function extendBounds(substations, lights) {
        var tempBounds = bounds;
        var totalNum = 0;
        if (substations && substations.length > 0) {
            totalNum += substations.length;
            tempBounds = extendItemBounds(tempBounds, substations);
        }
        if (lights && lights.length > 0) {
            totalNum += lights.length;
            tempBounds = extendItemBounds(tempBounds, lights);
        }
        if ((tempBounds === null || tempBounds === void 0 ? void 0 : tempBounds.isValid()) && totalNum > 1) {
            setBounds(tempBounds);
        }
    }
    function extendItemBounds(tempBounds, items) {
        items.map(function (item) {
            if (tempBounds === undefined) {
                tempBounds = L.latLngBounds([item.lat, item.lng], [item.lat, item.lng]);
            }
            else {
                tempBounds.extend([item.lat, item.lng]);
            }
        });
        return tempBounds;
    }
    function showPopModal() {
        setShowModal(!showModal);
    }
    var onGroupingChange = function (checked) {
        setGrouping(checked ? true : false);
        //sessionStorage.setItem(APPLICATION_KEY + 'grouping', JSON.stringify(checked ? true : false));
    };
    var showLightModal = function (light) {
        setLight(light);
        setLightVisible(true);
    };
    var showSubstationModal = function (substation) {
        setSubstation(substation);
        setSubstationVisible(true);
    };
    function addSubstationPopup(e, item) {
        setSubstationPopUp({
            key: new Date().getTime,
            position: e.latlng,
            item: item,
        });
    }
    function addPopup(e, item) {
        setPopUp({
            key: new Date().getTime,
            position: e.latlng,
            item: item,
        });
    }
    var MarkerSubstation = function (icon, item) {
        return (React.createElement(Marker, { icon: icon, position: [item.lat, item.lng], onClick: function (e) { return addSubstationPopup(e, item); } }));
    };
    var MarkerLight = function (icon, item) {
        return React.createElement(Marker, { icon: icon, position: [item.lat, item.lng], onClick: function (e) { return addPopup(e, item); } });
    };
    var MapMarkers = function () {
        return (React.createElement(React.Fragment, null,
            substations != null && (React.createElement(React.Fragment, null, substations.map(function (item, index) { return (React.createElement("div", { key: index }, MarkerSubstation(substationIcon, item))); }))),
            items != null && (React.createElement(React.Fragment, null, items.map(function (item, index) { return (React.createElement("div", { key: index },
                React.createElement(React.Fragment, null,
                    item.loadType === LOAD_TYPE.SEQUENCER && MarkerLight(sequencerIcon, item),
                    item.loadType === LOAD_TYPE.LUMINAIRE &&
                        item.status === LIGHT_STATUS.IDLE &&
                        MarkerLight(blueIcon, item),
                    item.loadType === LOAD_TYPE.LUMINAIRE &&
                        item.status === LIGHT_STATUS.NORMAL &&
                        MarkerLight(greenIcon, item),
                    item.loadType === LOAD_TYPE.LUMINAIRE &&
                        item.status === LIGHT_STATUS.BROKEN &&
                        MarkerLight(redIcon, item),
                    item.loadType === LOAD_TYPE.LUMINAIRE &&
                        item.status === LIGHT_STATUS.INACTIVE &&
                        MarkerLight(yellowIcon, item),
                    item.loadType === LOAD_TYPE.LUMINAIRE &&
                        item.status === LIGHT_STATUS.IDLE_HOLD_0 &&
                        MarkerLight(magentaIcon, item),
                    item.loadType === LOAD_TYPE.LUMINAIRE &&
                        item.status === LIGHT_STATUS.NORMAL_HOLD_0 &&
                        MarkerLight(orangeIcon, item)))); })))));
    };
    var MyComposedChart = function (props) {
        var formatter = function (value) { return "" + value + (props.yAxisUnit ? props.yAxisUnit : ''); };
        var CustomTooltip = function (data) {
            if (data.active) {
                return (React.createElement("div", { style: {
                        backgroundColor: 'white',
                        border: '1px solid lightgray',
                        padding: '5px',
                        borderRadius: '0.3em',
                    } },
                    React.createElement(Row, null,
                        React.createElement("span", null, data.label)),
                    data.payload != null &&
                        data.payload.map(function (entry) { return (React.createElement(Row, null,
                            React.createElement("span", { style: { color: entry.color } }, entry.value))); })));
            }
            return null;
        };
        return (React.createElement(Row, null,
            React.createElement(Col, { span: 24 },
                React.createElement("div", null,
                    React.createElement("div", { className: 'clsm-component-view-chart-container-title' },
                        React.createElement("div", { className: 'clsm-component-view-chart-title' }, props.title),
                        React.createElement("div", null, props.statistic)),
                    React.createElement(ResponsiveContainer, { width: "100%", height: props.height }, props.loading ? (React.createElement(Spin, null)) : (React.createElement(ComposedChart, { data: props.data, margin: {
                            top: 20,
                            right: 0,
                            left: 0,
                            bottom: 5,
                        } },
                        props.showTooltip && React.createElement(Tooltip, { content: React.createElement(CustomTooltip, null) }),
                        React.createElement(CartesianGrid, { strokeDasharray: "3 3", vertical: false }),
                        React.createElement(XAxis, { tick: { fill: JSON.parse(css_json)["special-font-color"] ? JSON.parse(css_json)["special-font-color"] : 'rgba(0, 0, 0, 0.85)' }, dataKey: props.xAxisDataKey ? props.xAxisDataKey : 'XAxisValue' }),
                        React.createElement(YAxis, { tick: { fill: JSON.parse(css_json)["special-font-color"] ? JSON.parse(css_json)["special-font-color"] : 'rgba(0, 0, 0, 0.85)' }, tickFormatter: formatter }),
                        React.createElement(Line, { type: "monotone", dataKey: "lineValue", stroke: props.lineColor ? props.lineColor : '#8884d8', dot: false }),
                        React.createElement(Bar, { dataKey: "barValue", fill: props.barColor ? props.barColor : '#8884d8', barSize: 5 })))),
                    React.createElement(Row, null,
                        props.customButton && props.customButton(),
                        props.customSwitch && props.customSwitch())))));
    };
    var MyLineChart = function (props) {
        var formatter = function (value) { return "" + value + (props.yAxisUnit ? props.yAxisUnit : ''); };
        var CustomTooltip = function (data) {
            if (data.active) {
                return (React.createElement("div", { style: {
                        backgroundColor: 'white',
                        border: '1px solid lightgray',
                        padding: '5px',
                        borderRadius: '0.3em',
                    } },
                    React.createElement(Row, null,
                        React.createElement("span", null, data.label)),
                    data.payload != null &&
                        data.payload.map(function (entry) { return (React.createElement(Row, null,
                            React.createElement("span", { style: { color: entry.color } }, entry.value))); })));
            }
            return null;
        };
        return (React.createElement(Row, null,
            React.createElement(Col, { span: 24 },
                React.createElement("div", null,
                    React.createElement("div", { className: 'clsm-component-view-chart-container-title' },
                        React.createElement("div", { className: 'clsm-component-view-chart-title' }, props.title),
                        React.createElement("div", null, props.statistic)),
                    React.createElement(ResponsiveContainer, { width: "100%", height: props.height }, props.loading ? (React.createElement(Spin, null)) : (React.createElement(LineChart, { data: props.data, margin: {
                            top: 20,
                            right: 0,
                            left: 0,
                            bottom: 5,
                        } },
                        props.showTooltip && React.createElement(Tooltip, { content: React.createElement(CustomTooltip, null) }),
                        React.createElement(CartesianGrid, { strokeDasharray: "3 3", vertical: false }),
                        React.createElement(XAxis, { tick: { fill: JSON.parse(css_json)["special-font-color"] ? JSON.parse(css_json)["special-font-color"] : 'rgba(0, 0, 0, 0.85)' }, dataKey: props.xAxisDataKey ? props.xAxisDataKey : 'XAxisValue' }),
                        React.createElement(YAxis, { tick: { fill: JSON.parse(css_json)["special-font-color"] ? JSON.parse(css_json)["special-font-color"] : 'rgba(0, 0, 0, 0.85)' }, tickFormatter: formatter }),
                        React.createElement(Line, { type: "monotone", dataKey: "value", stroke: props.lineColor ? props.lineColor : '#8884d8', dot: false })))),
                    React.createElement(Row, null,
                        props.customButton && props.customButton(),
                        props.customSwitch && props.customSwitch())))));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("section", { id: css_id, className: "clsm-component-view-container" },
            jsonData.title != null && React.createElement("div", { className: 'clsm-component-view-title' },
                " ",
                React.createElement(HeaderTextDivider, { title: getTranslated(jsonData.title, selLang) })),
            projectType === 'admin' && fetchError === true && React.createElement("div", null, geti18nText('component.clsmviewcomponent.fetch.error')),
            jsonData.type === 'map' && fetchError === false && React.createElement("div", { className: 'clsm-component-view-content', id: "container", style: { position: 'relative' } },
                currentConsumption && (React.createElement("span", { className: 'clsm-component-view-map-text', style: { position: 'absolute', bottom: '30px', left: '10px', zIndex: 1000 } },
                    getTranslated(jsonData.textCurrentPower, selLang),
                    ":",
                    ' ',
                    React.createElement("b", { className: 'clsm-component-view-map-text-value' },
                        currentConsumption.currentPower,
                        " ",
                        'kW'))),
                currentConsumption && (React.createElement("span", { className: 'clsm-component-view-map-text', style: { position: 'absolute', bottom: '10px', left: '10px', zIndex: 1000 } },
                    getTranslated(jsonData.textExpectedPower, selLang),
                    ":",
                    ' ',
                    React.createElement("b", { className: 'clsm-component-view-map-text-value' },
                        currentConsumption.expectedPower,
                        " ",
                        'kW'))),
                React.createElement(Map, { style: { height: '83vh' }, center: [45.74497120551588, 16.10733032226563], zoom: 5, bounds: bounds },
                    React.createElement(Switch, { style: { width: '100px', top: '80px', left: '10px', zIndex: 1000 }, checkedChildren: getTranslated(jsonData.textBtnNormal, selLang), unCheckedChildren: getTranslated(jsonData.textBtnGrouped, selLang), defaultChecked: grouping, onChange: onGroupingChange }),
                    React.createElement(TileLayer, { attribution: "", url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" }),
                    grouping && grouping === true && (React.createElement(MarkerClusterGroup, { disableClusteringAtZoom: 18, animate: false }, MapMarkers())),
                    !grouping && React.createElement(React.Fragment, null,
                        " ",
                        MapMarkers(),
                        " "),
                    popUp && (React.createElement(Popup, { key: popUp.key, offset: [0, -30], position: popUp.position, onClose: function () { return setPopUp(null); } },
                        getTranslated(jsonData.textFactoryId, selLang),
                        ": ",
                        React.createElement("b", null, popUp.item.factoryId),
                        " ",
                        React.createElement("br", null),
                        getTranslated(jsonData.textPower, selLang),
                        ": ",
                        React.createElement("b", null, popUp.item.power),
                        " ",
                        React.createElement("br", null),
                        getTranslated(jsonData.textType, selLang),
                        ": ",
                        React.createElement("b", null, popUp.item.type),
                        " ",
                        React.createElement("br", null),
                        getTranslated(jsonData.textInitialHoldS, selLang),
                        ": ",
                        React.createElement("b", null, popUp.item.initialHoldS),
                        " ",
                        React.createElement("br", null),
                        getTranslated(jsonData.textPhase, selLang),
                        ": ",
                        React.createElement("b", null, popUp.item.phase),
                        " ",
                        React.createElement("br", null),
                        getTranslated(jsonData.textSequencerSerial, selLang),
                        ": ",
                        React.createElement("b", null, popUp.item.sequencerSerial),
                        " ",
                        React.createElement("br", null),
                        getTranslated(jsonData.textDevice, selLang),
                        ": ",
                        React.createElement("b", null, popUp.item.device && popUp.item.device.name),
                        " ",
                        React.createElement("br", null),
                        getTranslated(jsonData.textSubstation, selLang),
                        ":",
                        ' ',
                        React.createElement("b", null, popUp.item.substation && popUp.item.substation.substationId),
                        " ",
                        React.createElement("br", null),
                        getTranslated(jsonData.textStatus, selLang),
                        ":",
                        ' ',
                        React.createElement("b", null, getTranslated(jsonData["textStatus" + popUp.item.status], selLang)),
                        " ",
                        React.createElement("br", null),
                        React.createElement("br", null))),
                    substationPopUp && (React.createElement(Popup, { key: substationPopUp.key, offset: [0, -30], position: substationPopUp.position, onClose: function () { return setSubstationPopUp(null); } },
                        getTranslated(jsonData.textSubstation, selLang),
                        ": ",
                        React.createElement("b", null, substationPopUp.item.substationId),
                        ' ')))),
            jsonData.type === 'chart' && fetchError === false && React.createElement("div", { className: 'clsm-component-view-content' },
                " ",
                React.createElement(Row, { gutter: 24 },
                    React.createElement(Col, { xs: 24, xl: 12 },
                        React.createElement(MyComposedChart, { showTooltip: true, loading: loading, height: 300, 
                            //customButton={() => MeasurementReportButton('power')}
                            //customSwitch={() => MeasurementReportMailSwitch('power')}
                            barColor: JSON.parse(css_json)["primary-color"] ? JSON.parse(css_json)["primary-color"] : '#79daa3', lineColor: JSON.parse(css_json)["secondary-color"] ? JSON.parse(css_json)["secondary-color"] : '#ff0000', title: getTranslated(jsonData.chartTitlePower, selLang), statistic: React.createElement(Statistic, { title: getTranslated(jsonData.chartTextPower, selLang), value: (powerMax ? powerMax : 0) + 'kW' }), data: chartPower, xAxisDataKey: 'converted', yAxisUnit: ' kW' })),
                    React.createElement(Col, { xs: 24, xl: 12 },
                        React.createElement(MyLineChart, { showTooltip: true, loading: loading, height: 300, 
                            //customButton={() => MeasurementReportButton('energy')}
                            //customSwitch={() => MeasurementReportMailSwitch('energy')}
                            lineColor: JSON.parse(css_json)["primary-color"] ? JSON.parse(css_json)["primary-color"] : '#79daa3', title: getTranslated(jsonData.chartTitleEnergy, selLang), statistic: React.createElement(Statistic, { title: getTranslated(jsonData.chartTextEnergy, selLang), value: (energyMax ? energyMax : 0) + 'kWh' }), data: chartEnergy, xAxisDataKey: 'converted', yAxisUnit: ' kWh' })))))));
};
export default ClsmViewComponent;
export var LOAD_TYPE = {
    LUMINAIRE: 0,
    SEQUENCER: 1,
};
export var LIGHT_STATUS = {
    IDLE: 0,
    NORMAL: 1,
    BROKEN: 2,
    INACTIVE: 3,
    IDLE_HOLD_0: 4,
    NORMAL_HOLD_0: 5,
};
//# sourceMappingURL=index.js.map